<template>
  <el-form ref="form" :model="dataInfo"  :rules="rules" :hide-required-asterisk="true" label-position="top">

    <!-- 基本情况 -->
    <div class="white-box">
      <div class="flex-row">
        <div class="label" >核心成员（除申报人外）</div>
        <div style="flex:1"/>
        <div v-if="showDeleteBtn && !disabled" class="delete-btn" @click="deleteCoreUser">删除成员</div>
      </div>
      <el-row :gutter="20">
        <el-col :span="8">
          <el-form-item label="姓名" prop="name">
            <el-input v-model="dataInfo.name" placeholder="请输入" :disabled="disabled"/>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="性别" prop="sex">
            <el-radio-group v-model="dataInfo.sex" :disabled="disabled">
              <el-radio :label="item.value" v-for="(item) in sexOptions" :key="item.value">{{item.label}}</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="年龄" prop="age">
            <el-input v-input.num v-model="dataInfo.age" placeholder="请输入" :disabled="disabled"/>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="8">
          <el-form-item label="学历" prop="xl">
            <el-select v-model="dataInfo.xl" placeholder="请选择" :disabled="disabled">
              <el-option v-for="item in highestEducationOptions" :key="item.value" :label="item.label" :value="item.value"/>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="国籍" prop="gj">
            <el-input v-model="dataInfo.gj" placeholder="请输入" :disabled="disabled"/>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="有效证件号码" prop="zjhm">
            <el-input v-model="dataInfo.zjhm" placeholder="请输入" :disabled="disabled"/>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="8">
          <el-form-item label="联系电话" prop="phone">
            <el-input v-model="dataInfo.phone" placeholder="请输入"  :disabled="disabled"/>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="电子邮箱" prop="email">
            <el-input v-model="dataInfo.email" placeholder="请输入" :disabled="disabled"/>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="联系地址" prop="lxdz">
            <el-input v-model="dataInfo.lxdz" placeholder="请输入" :disabled="disabled"/>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="24">
          <el-form-item label="身份证或护照" prop="coreSfzFileIdList">
            <custom-upload v-model="dataInfo.coreSfzFileIdList" :disabled="disabled"/>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="24">
          <el-form-item label="学历学位证书" prop="xlxwFileIdList">
            <custom-upload v-model="dataInfo.xlxwFileIdList"  :disabled="disabled"/>
          </el-form-item>
        </el-col>
      </el-row>
    </div>

    <!-- 学习经历 -->
    <div class="white-box">
      <div class="flex-row">
        <div class="label">个人学习及工作履历</div>
      </div>

      <el-form-item label="" prop="workAndStudyList">
        <el-table :data="dataInfo.workAndStudyList" border>
          <el-table-column label="起止年月" width="200" align="center" >
            <template slot-scope="scope">
              <el-date-picker v-model="scope.row.times" type="monthrange" value-format="yyyy-MM" start-placeholder="开始时间" end-placeholder="结束时间" @change="val=> timeChange(val, scope.row)" :disabled="disabled"/>
            </template>
          </el-table-column>
          <el-table-column label="学习或工作单位" min-width="350" align="center">
            <template slot-scope="scope">
              <el-input v-model="scope.row.xyhgzdw" placeholder="请输入"  :disabled="disabled"/>
            </template>
          </el-table-column>
          <el-table-column label="学习专业或职业（获取学位及职务）"  align="center" min-width="350">
            <template slot-scope="scope">
              <el-input v-model="scope.row.zyzw" placeholder="请输入"  :disabled="disabled"/>
            </template>
          </el-table-column>

          <el-table-column label="" align="center"  width="60" v-if="!disabled">
            <template slot-scope="scope">
              <i class="el-icon-delete" style="font-size: 16px;color:red;cursor: pointer" @click="deleteStudyExp(scope.$index)"></i>
            </template>
          </el-table-column>

        </el-table>

        <div class="add-line" @click="addStudyExp"  v-if="!disabled">
          <i class="el-icon-plus" ></i><span>添加</span>
        </div>
      </el-form-item>

    </div>

    <!-- 业绩及荣誉 -->
    <div class="white-box">
      <div class="label">业绩及荣誉</div>

      <el-form-item label="荣誉及奖励" prop="ryjjl">
        <el-input v-model="dataInfo.ryjjl" placeholder="请输入" type="textarea" :rows="4" :disabled="disabled"/>
      </el-form-item>

      <el-form-item label="主要技术成果" prop="zyjscg">
        <el-input v-model="dataInfo.zyjscg" placeholder="请输入" type="textarea" :rows="4" :disabled="disabled"/>
      </el-form-item>

      <el-form-item label="主持国家和地方科技业项目及资助情况" prop="zzqkList">
        <el-table :data="dataInfo.zzqkList" border >
          <el-table-column label="项目类别" min-width="180" align="center">
            <template slot-scope="scope">
              <el-input v-model="scope.row.projectCategory" placeholder="" placeholder="请输入" :disabled="disabled"/>
            </template>
          </el-table-column>
          <el-table-column label="项目名称" min-width="360" align="center">
            <template slot-scope="scope">
              <el-input v-model="scope.row.projectName" placeholder="" placeholder="请输入" :disabled="disabled"/>
            </template>
          </el-table-column>
          <el-table-column label="资助金额（万元）"  align="center" min-width="180">
            <template slot-scope="scope">
              <el-input v-input.float v-model="scope.row.amount" placeholder="" placeholder="请输入" :disabled="disabled"/>
            </template>
          </el-table-column>

          <el-table-column label="" align="center"  width="60" v-if="!disabled">
            <template slot-scope="scope">
              <i class="el-icon-delete" style="font-size: 16px;color:red;cursor: pointer" @click="deleteZzqk(scope.$index)"></i>
            </template>
          </el-table-column>

        </el-table>
        <div class="add-line" @click="addZzqk"  v-if="!disabled">
          <i class="el-icon-plus" ></i><span>添加</span>
        </div>
      </el-form-item>

      <el-form-item label="职称证书【选填】" prop="zczsFileIdList">
        <custom-upload v-model="dataInfo.zczsFileIdList" :disabled="disabled"/>
      </el-form-item>

      <el-form-item label="各类成果和奖项【选填】" prop="glcgFileIdList">
        <custom-upload v-model="dataInfo.glcgFileIdList" :disabled="disabled"/>
      </el-form-item>

      <div class="btn-box" v-if="!disabled">
        <el-button class="add" type="primary" icon="el-icon-plus" @click="addCoreUser">新增核心成员</el-button>
      </div>

    </div>


  </el-form>
</template>

<script>

import {toast} from '@/utils'
import {findByKey, toList, SEX_TYPE, HIGHEST_EDUCATION} from '@/constant/Enums'
import CustomUpload from '@/components/custom-upload'

export default {
  components: {
    CustomUpload,
  },
  props: {
    dataInfo: {
      type: Object,
      default: ()=>{
        return {
          workAndStudyList: [{}],//个人学习及工作履历
          zzqkList: [{}],//主持国家和地方科技业项目及资助情况
          coreSfzFileIdList:[],//身份证或护照
          xlxwFileIdList:[],//学历学位证书
          zczsFileIdList:[],//职称证书
          glcgFileIdList:[],//各类成果和奖项
        }
      },
    },
    showDeleteBtn: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    parent:{
      type:Object
    }
  },
  data() {
    //校验列表数据
    var checkList = (rule, value, callback, paramsList, canEmptyList) => {
      let isPass = true
      value.forEach((data)=>{
        if(paramsList && paramsList.length > 0) {
          paramsList.forEach(params=>{
            if(!data[params] && data[params] !== 0) {
              isPass = false
            }
          })
        }
      })
      if (!isPass || (!canEmptyList && value.length == 0)) {
        return callback(new Error());
      } else {
        return callback();
      }
    };
    //工作及学习经历
    var checkWorkAndStudyList = (rule, value, callback) => {
      let paramsList = ['startDate', 'endDate', 'xyhgzdw', 'zyzw']
      return checkList(rule, value, callback, paramsList)
    };
    //主持国家和地方科技业项目及资助情况
    var checkZzqkList = (rule, value, callback) => {
      let paramsList = ['projectCategory', 'projectName', 'amount']
      return checkList(rule, value, callback, paramsList, true)
    };
    var checkEmail = (rule, value, callback) => {
      const MONEY_REGEX = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      if(!MONEY_REGEX.test(value)) {
        return callback(new Error());
      } else {
        return callback();
      }
    };
    var checkPhone = (rule, value, callback) => {
      const MONEY_REGEX = /^1[0-9]{10}$/;
      if(!MONEY_REGEX.test(value)) {
        return callback(new Error());
      } else {
        return callback();
      }
    };
    var checkFileList = (rule, value, callback, paramName) => {
        console.log('this.dataInfo', JSON.stringify(this.dataInfo))
      if (this.dataInfo[paramName].length == 0) {
        return callback(new Error());
      } else {
        return callback();
      }
    };
    return {
      rules: {
        name: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
        sex: [{ required: true, message: '请选择性别', trigger: 'change' }],
        age: [{ required: true, message: '请输入年龄', trigger: 'blur' }],
        xl: [{ required: true, message: '请选择学历', trigger: 'change' }],
        gj: [{ required: true, message: '请输入国籍', trigger: 'blur' }],
        zjhm: [{ required: true, message: '请输入有效证件号码', trigger: 'blur' }],
        phone: [
            { required: true, message: '请输入联系电话', trigger: 'blur' },
          { validator: checkPhone, message: '手机号格式不正确', trigger: 'blur' },
            ],
        email: [
            { required: true, message: '请输入电子邮箱', trigger: 'blur' },
          { validator: checkEmail, message: '邮箱格式不正确', trigger: 'blur' },
        ],
        lxdz: [{ required: true, message: '请输入联系地址', trigger: 'blur' }],
        coreSfzFileIdList: [{ required: true, validator: (rule, value, callback)=> checkFileList(rule, value, callback, 'coreSfzFileIdList'), message: '请上传身份证或护照', trigger: 'blur' }],
        xlxwFileIdList: [{ required: true, validator: (rule, value, callback)=> checkFileList(rule, value, callback, 'xlxwFileIdList'), message: '请上传学历学位证书', trigger: 'blur' }],
        workAndStudyList: [{ validator: checkWorkAndStudyList, message: '请填写个人学习及工作履历', trigger: 'change' }],
        ryjjl: [{ required: true, message: '请输入荣誉及奖励', trigger: 'blur' }],
        zyjscg: [{ required: true, message: '请输入主要技术成果', trigger: 'blur' }],
        zzqkList: [{ validator: checkZzqkList, message: '请填写主持国家和地方科技业项目及资助情况', trigger: 'change' }],
      },
      sexOptions:toList(SEX_TYPE),//性别类型
      highestEducationOptions:toList(HIGHEST_EDUCATION),//最高学历

    }
  },
  watch: {
  },
  computed: {
  },
  mounted() {
    this.$emit('onMounted', this)
  },
  beforeDestroy() {
    this.$emit('onDestroy', this)
  },
  methods: {
    addStudyExp(){
      this.dataInfo.workAndStudyList.push({})
    },
    deleteStudyExp(index){
      this.dataInfo.workAndStudyList.splice(index, 1)
    },
    timeChange(times, data){
      if(times && times.length > 1) {
        data.startDate = times[0]
        data.endDate = times[1]
      } else {
        data.startDate = ''
        data.endDate = ''
      }
    },
    addZzqk(){
      this.dataInfo.zzqkList.push({})
    },
    deleteZzqk(index){
      this.dataInfo.zzqkList.splice(index, 1)
    },
    addCoreUser(){
      this.$emit('addCoreUser')
    },
    deleteCoreUser(){
      this.$emit('deleteCoreUser', this.dataInfo)
    },
    validate(callback){
      this.$refs['form'].validate((valid, object) => {
        callback && callback(valid, object)
      });
    },
    resetFields(){
      this.$refs['form'].resetFields();
    },
  },
}
</script>

<style lang='less' scoped>
  @import url(./index.less);
</style>
